import { gql, OperationVariables, useLazyQuery } from "@apollo/client"
import { EmployerOfRecordCollection } from "@oysterhr/schema"

export const EMPLOYERS_OF_RECORD_STAFF_GET_EOR_BY_COUNTRY_CODE = gql`
  query EmployersOfRecordStaffGetEoRByCountryCode(
    $countryCode: String!
    $engagementId: ID
    $query: String
  ) {
    employersOfRecord(countryCode: $countryCode, engagementId: $engagementId, query: $query) {
      collection {
        id
        name
      }
    }
  }
`

export const useEor = (options: OperationVariables) =>
  useLazyQuery<{ employersOfRecord: EmployerOfRecordCollection }>(
    EMPLOYERS_OF_RECORD_STAFF_GET_EOR_BY_COUNTRY_CODE,
    options,
  )
